import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MessageService} from 'primeng/api';
import {filter} from 'rxjs/operators';
import {IdleLockService} from './_services';

@Component({
  selector: 'app-root',
  template: ` <router-outlet></router-outlet>
  <p-toast position="top-right"></p-toast>`
})
export class AppComponent implements OnInit {

    constructor(translate: TranslateService, private router: Router, private idleLock: IdleLockService) {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('de');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        const language = localStorage.getItem('Language');
        if (language) translate.use(language);

        // JS-1396: <html> carried no lang attribute at all, so the browser had
        // no language to hyphenate by. Combined with the break-word rules in
        // the alert and toast styles, long German compounds were chopped
        // mid-word with no hyphen ("Wiederherstellungsco|des"). English words
        // are short enough never to trigger it, which is why it only showed in
        // de. Setting lang lets `hyphens: auto` break at real syllable
        // boundaries instead.
        document.documentElement.lang = language || 'de';
        translate.onLangChange.subscribe(event => {
            document.documentElement.lang = event.lang;
        });
    }

    ngOnInit() {
        // JS-1802: when another tab of this browser switches the agency (or
        // logs in/out), reload so this tab never shows the previous pool's data.
        window.addEventListener('storage', (event: StorageEvent) => {
            if (event.key !== 'currentUser' || event.oldValue === event.newValue) { return; }
            let oldAgency = null; let newAgency = null;
            try { oldAgency = JSON.parse(event.oldValue)?.agency_id; } catch (e) {}
            try { newAgency = JSON.parse(event.newValue)?.agency_id; } catch (e) {}
            if (oldAgency !== newAgency) {
                window.location.reload();
            }
        });

        // JS-1929: on phones every screen opens fitted to the screen, whatever the zoom on the previous one
        let lastPath = window.location.pathname;
        this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
            const path = window.location.pathname;
            if (path === lastPath) { return; }
            lastPath = path;
            (window as any).jrApplyMobileViewport?.(path);
        });

        // JS-1396 idle lock: passkey re-verification after inactivity.
        this.idleLock.start();
    }
}
